import React, { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { Flex, View, SelectField } from '@aws-amplify/ui-react';
import { listEventLists } from '../../graphql/queries';
import { rhUtc2pst } from '../helpers';
import { fetchRunDetails } from '../shared/raceheroUtilities';

async function listEvents() {
  const maxPages = 100;
  let nextToken;
  let fullResponse = [];
  try {
    let x = 0;
    while (x < maxPages) {
      const apiData = await API.graphql({
        query: listEventLists,
        variables: {
          limit: 1000,
          nextToken: nextToken,
        },
      });
      const eventsFromAPI = apiData.data.listEventLists.items;
      for (const ev of eventsFromAPI) {
        const eventJson = JSON.parse(ev.eventJson);
        fullResponse.push(eventJson);
      }
      nextToken = apiData.data.listEventLists.nextToken;
      if (nextToken === null) {
        break;
      }
      x++;
    }
    fullResponse.sort(
      (a, b) => new Date(b.started_at) - new Date(a.started_at)
    );
    return fullResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export const EventGroupRaceCarnumSelectorNew = ({
  selectedRunDetails,
  liftSelectedRunDetails,
}) => {
  const [eventData, setEventData] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [selectedRunId, setSelectedRunId] = useState(null);
  const [selectedCarnum, setSelectedCarnum] = useState(null);

  useEffect(() => {
    async function asyncWrapper() {
      const res = await listEvents();
      setEventData(res);
    }
    asyncWrapper();
  }, []);

  async function getRunDetails(event_id, run_id) {
    liftSelectedRunDetails(await fetchRunDetails(event_id, run_id));
  }

  async function updateRunDetails(racer_id) {
    liftSelectedRunDetails((d) => ({ ...d, racerId: racer_id }));
  }

  const activeGroups = eventData.find(
    (event) => String(event.id) === selectedEventId
  )?.groups;
  const activeRuns =
    activeGroups
      ?.find((group) => String(group.id) === selectedGroupId)
      ?.runs.slice()
      .sort((a, b) => a.id - b.id) || null;
  const racerArray =
    selectedRunDetails?.runJson?.racers
      .slice()
      .sort((a, b) => a.racer_number - b.racer_number) || null;

  return (
    <View>
      <Flex direction="column" justifyContent="center">
        <SelectField
          name="eventid2"
          value={selectedEventId}
          placeholder="Select Event"
          defaultValue="none "
          required
          onChange={(e) => {
            setSelectedEventId(e.target.value);
            // clear downstream select data
            setSelectedGroupId(null);
            setSelectedRunId(null);
            setSelectedCarnum(null);
            liftSelectedRunDetails({});
          }}
        >
          {eventData?.map((option, index) => (
            <option key={option.id} value={option.id}>
              {option.id} - {rhUtc2pst(option.started_at)} - {option.name} -{' '}
              {option.venue?.name}
            </option>
          ))}
        </SelectField>
        <SelectField
          name="groupid"
          value={selectedGroupId}
          placeholder="Select Group"
          required
          onChange={(e) => {
            setSelectedGroupId(e.target.value);
            // clear downstream select data
            setSelectedRunId(null);
            setSelectedCarnum(null);
            liftSelectedRunDetails({});
          }}
        >
          {activeGroups &&
            activeGroups.map((option, index) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
        </SelectField>
        <SelectField
          name="runid"
          value={selectedRunId}
          placeholder="Select Run"
          required
          onChange={(e) => {
            setSelectedRunId(e.target.value);
            getRunDetails(selectedEventId, e.target.value);
            // clear downstream select data
            setSelectedCarnum(null);
            liftSelectedRunDetails({});
          }}
        >
          {activeRuns?.map((option, index) => (
            <option key={option.id} value={option.id}>
              {option.id} - {rhUtc2pst(option.started_at, true)} - {option.name}
            </option>
          ))}
        </SelectField>
        <SelectField
          name="carnum"
          value={selectedCarnum}
          placeholder="Select your car number"
          required
          onChange={(e) => {
            updateRunDetails(e.target.value);
            setSelectedCarnum(e.target.value);
          }}
        >
          {selectedRunDetails &&
            racerArray?.map((option, index) => (
              <option key={option.id} value={option.racer_number}>
                {option.racer_number} - {option.name}
              </option>
            ))}
        </SelectField>
      </Flex>
    </View>
  );
};
